import { AlertCircle, CheckCircle2, MinusCircle } from 'lucide-react'

// The per-system outcome list shown after an action that touches several
// systems at once (editing or deleting a customer). Every system reports on
// its own, so the admin sees exactly what changed where and what to fix.

export interface SyncResult {
	system: 'cbb' | 'chargebee' | 'brevo' | 'nextcloud'
	status: 'updated' | 'skipped' | 'failed'
	message: string
}

const SYSTEM_LABELS: Record<SyncResult['system'], string> = {
	cbb: 'CBB account',
	chargebee: 'Chargebee',
	brevo: 'Brevo',
	nextcloud: 'Nextcloud',
}

export function SyncResultList({ results }: { results: SyncResult[] }) {
	return (
		<ul className="mt-3 divide-y divide-line rounded-lg border border-line">
			{results.map((r) => (
				<li key={r.system} className="flex gap-3 p-3">
					<ResultIcon status={r.status} />
					<div className="min-w-0">
						<div className="text-sm font-medium">{SYSTEM_LABELS[r.system]}</div>
						<div className="break-words text-xs text-ink-soft">{r.message}</div>
					</div>
				</li>
			))}
		</ul>
	)
}

function ResultIcon({ status }: { status: SyncResult['status'] }) {
	if (status === 'updated') return <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" />
	if (status === 'failed') return <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-red-600" />
	return <MinusCircle className="mt-0.5 h-4 w-4 shrink-0 text-ink-faint" />
}
